<template>
  <div id="app">
    <div id="app-header">
      <div @click="() => {
        isCollapse = !isCollapse
      }" :style="{
        backgroundColor: isCollapse ? 'transparent' : 'var(--primary-header-active-color)',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        height: 'var(--primary-header-height)'
      }">
        <i :class="isCollapse ? 'fa fa-bars' : 'fa fa-close'" style="color: white; font-size: 26px;"></i>
      </div>
      <router-link to="/"><h3 style="color: white; text-decoration: none; padding-right: 32px;">必卖多</h3></router-link>
      <div style="flex: 1; display: flex; justify-content: flex-start;">
        <el-select v-model="defaultSiteId" placeholder="请选择您需要管理的站点" @change="changeSite" size="mini" style="margin-right: 16px;" filterable>
          <el-option v-for="site in Sites" :key="site.ID" :label="site.shortName ? site.CountryCode.toUpperCase() + '@' + site.shortName : '未命名店铺'" :value="site.ID">
            <span style="float: left">{{ site.shortName ? site.shortName : '未命名店铺' }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ site.CountryCode ? site.CountryCode.toUpperCase() : '未配置国家代码' }}</span>
          </el-option>
        </el-select>
      </div>
      <div id="topbar">
        <el-dropdown>
          <span class="el-dropdown-link" style="color: white; font-size: 10px;">
            <i class="fa fa-user"></i>用户中心<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>组织构架</el-dropdown-item>
            <el-dropdown-item>员工审核</el-dropdown-item>
            <el-dropdown-item>用户信息</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="text" style="color: white!important; font-size: 10px;"><a href="https://iam.jobday.net" style="color: white; text-decoration: none;" target="_blank"><i class="fa fa-hand-o-up"></i>提交工单</a></el-button>
        <el-button type="text" style="color: white!important; font-size: 10px;" @click="showRecharge = true"><i class="fa fa-paypal"></i>在线充值</el-button>
        <el-button type="text" style="color: white!important; font-size: 10px;"  @click="sigout"><i class="fa fa-sign-out"></i>退出登陆</el-button>
      </div>
    </div>
     <div style="padding: 16px; position: relative;">
       <div id="sidebar" :style="{
         width: `${getSidebarWidth()}`
       }">
         <el-menu default-active="4" unique-opened @select="() => {
           console.log(e)
         }" style="width: var(--primary-sidebar-width)" size="small" background-color="var(--primary-sidebar-bgcolor)" class="el-menu-vertical-menu" @open="(e) => {
         }"  :collapse="isCollapse">
           <el-submenu v-for="mn in menusData" :key="mn.ID" :index="`${mn.ID}`">
             <template slot="title">
               <i :class="mn.icon"></i>
               <span slot="title">{{ mn.name }}</span>
             </template>
             <el-menu-item v-for="cl in mn.child" :key="cl.ID" :index="cl.uri">
               <a class="app-nav-link" :href="`/${cl.uri}`">{{ cl.name }}</a>
             </el-menu-item>
           </el-submenu>
         </el-menu>
       </div>
       <div id="sub-service" v-if="subService.length > 0"></div>
       <div id="app-body" :style="{
            width: subService.length > 0 ? `calc(100% - var(--primary-subservice-width) - ${getSidebarWidth()})` : `calc(100% - ${getSidebarWidth()})`,
            left:  subService.length > 0 ? `calc(var(--primary-subservice-width) + ${getSidebarWidth()})` : `${getSidebarWidth()}`
          }">
         <div style="width: 90%; height: calc(100vh - var(--primary-header-height) - 60px); text-align: left; background-color: white; padding: 26px; border-radius: 26px; overflow-y: auto;">
           <router-view/>
         </div>

       </div>
     </div>
    <el-dialog :visible.sync="showRecharge" width="30%">
      <el-form :model="rechargeValue" name="rechargeForm" ref="rechargeForm">
        <el-form-item label="充值金额" prop="money" required>
          <el-input v-model="rechargeValue.money" placeholder="请输入充值金额"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="success" @click="recharge('rechargeForm')"><i class="fa fa-usd"></i>立即充值</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
</div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      menusData: [],
      showRecharge: false,
      rechargeValue: {},
      load: '',
      defaultSite: {},
      defaultSiteId: '',
      Sites: [],
      isCollapse: true,
      subService: [],
      activeIndex: '4'
    }
  },
  mounted: function () {
    this.menuLoad()
    document.title = '必卖多 - 多渠道零售解决方案'
    this.getSites()
  },
  methods: {
    getSidebarWidth: function () {
      return this.isCollapse ? 'var(--primary-sidebar-width)' : 'var(--primary-sidebar-uncollapse-width)'
    },
    changeSite: function (siteId) {
      var that = this
      var para = {}
      para.shopId = siteId
      para.method = 'shop.markDefaultSite'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.body.data.code === 200) {
          window.location.reload()
        } else {
          that.$message.error('站点切换失败，请稍后重试!')
        }
      })
    },
    getSites: function () {
      var that = this
      var para = {}
      para.method = 'shop.usershopsites'
      para.page = 1
      para.num = 9000
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.defaultSite = ret.body.data.default
        that.defaultSiteId = ret.body.data.default.ID
        that.Sites = ret.body.data.data
      })
    },
    menuLoad: function () {
      var that = this
      this.$http.post(that.$apiurl, {method: 'base.getmenu', service: 1}).then(function (ret) {
        var data = ret.body.data
        for (var i = 0; i < data.length; i++) {
          this.menusData.push(data[i])
        }
      })
    },
    sigout: function () {
      localStorage.removeItem('token')
      setTimeout(function () {
        window.location.reload()
      }, 2000)
    },
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    recharge: function (formname) {
      var that = this
      this.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.rechargeValue
          that.fullLoad()
          para.method = 'merchant.recharge'
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              window.open(ret.body.data.url, '_blank')
            } else {
              that.$message.error('支付请求失败，请稍后重试')
            }
          })
        }
      })
    }
  }
}
</script>
<style>
  body{margin: 0; background: rgba(240,240,240,0.8);}
  .logotitle{font-weight: bolder; font-size: 22px;}
  .el-menu-item .a{text-decoration: none;}
  .menulink{text-decoration: none; color: #606266;}
  .el-menu-item-group .is-active{background-color: #C0C4CC; color: white;}
  .topmenu a{color: white; text-decoration: none!important;}
</style>



// WEBPACK FOOTER //
// src/App.vue